import { useEffect, useRef, useState } from 'react';

import type { Campsite } from '@/types/domain';

import campSiteIdsToCampSite from './campSiteIdsToCampSite';

export default (campSiteId?: string) => {
  const [campSites, setCampSite] = useState<Campsite[]>([]);
  const refFirstRef = useRef(true);
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      if (refFirstRef.current) {
        refFirstRef.current = false;
      }
    }
    const ids =
      JSON.parse(localStorage.getItem('browsingHistoryCampSiteIds') ?? '[]') ??
      [];
    campSiteIdsToCampSite(
      ids
        .reverse()
        .filter((id: string) => id !== campSiteId)
        .slice(0, 6)
    ).then((res) => {
      setCampSite(res);
    });
  }, []);
  useEffect(() => {
    if (!campSiteId) {
      return;
    }
    const ids =
      JSON.parse(localStorage.getItem('browsingHistoryCampSiteIds') ?? '[]') ??
      [];
    ids.push(campSiteId);
    localStorage.setItem(
      'browsingHistoryCampSiteIds',
      JSON.stringify(Array.from(new Set(ids)))
    );
  }, [campSiteId]);
  return {
    campSites,
  };
};
